import has from 'lodash/has';
import React, { PropTypes } from 'react';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { fixedEncodeURIComponent } from '@bibliocommons/utils-browser';
import { Angle } from '@bibliocommons/base-icons';

import './ExternalSearchLink.scss';

function getLocalizationKey(searchType) {
  switch (searchType) {
    case 'title':
      return 'external_search_link_title';
    case 'author':
      return 'external_search_link_author';
    case 'subject':
      return 'external_search_link_subject';
    case 'keyword':
    case 'catalogue':
    case 'smart':
      return 'external_search_link_keyword';
    default:
      return '';
  }
}

function screenReaderMessage(linkText) {
  return (
    <ScreenReaderMessage>
      <FormattedMessage id="ada_opens_a_new_tab" values={{ linkText }} />
    </ScreenReaderMessage>
  );
}

function getfindOutMoreAdditionalLink(intl) {
  return (
    has(intl.messages, 'find_out_more_additional_link') ? intl.formatMessage({ id: 'find_out_more_additional_link' }) : null
  );
}

function getExternalSearchUrl(intl, query, backlink, searchType) {
  return (
    has(intl.messages, getLocalizationKey(searchType)) ?
    intl.formatHTMLMessage({
      defaultMessage: '',
      id: getLocalizationKey(searchType)
    }, {
      q: fixedEncodeURIComponent(query),
      backlink
    }) : null
  );
}

function formattedExternalSearch(intl, url, linkText) {
  return (
    <div className="cp-external-search-link">
      <div className="external-search-name">
        { linkText }
      </div>
      <a
        href={url}
        className="external-search-link"
        target="_blank"
        rel="noopener noreferrer">
        <FormattedMessage id="search_link_text" />
        {screenReaderMessage(linkText)}
        <Angle.Right />
      </a>
      <div className="additional-link">
        { getfindOutMoreAdditionalLink(intl) &&
          (<a
            href={getfindOutMoreAdditionalLink(intl)}
            className="find_out_more_additional_link"
            target="_blank"
            rel="noopener noreferrer">
            <span aria-hidden>
              <FormattedMessage id="find_out_more_link" />
            </span>
            {screenReaderMessage(<FormattedMessage id="find_out_more_link" />)}
          </a>)
        }
      </div>
    </div>
  );
}

function externalSearchLinkOnly(url, linkText) {
  return (
    <a
      href={url}
      className="cp-external-search-link"
      target="_blank"
      rel="noopener noreferrer">
      <span aria-hidden>
        { linkText }
      </span>
      {screenReaderMessage(linkText)}
      <Angle.Right />
    </a>
  );
}

function ExternalSearchLink({ intl, query, searchType, formatted }) {
  const url = getExternalSearchUrl(intl, query, __CLIENT__ ? window.location.href : '', searchType);

  const linkText = (
    <span>
      <FormattedHTMLMessage id="external_search_link_line1" defaultMessage="" />
      &nbsp;
      { intl.messages.external_search_link_line2 ? <FormattedHTMLMessage id="external_search_link_line2" defaultMessage="" /> : null }
      &nbsp;
    </span>
  );

  if (!url) {
    return null;
  }

  return formatted ? formattedExternalSearch(intl, url, linkText) : externalSearchLinkOnly(url, linkText);
}

ExternalSearchLink.defaultProps = {
  formatted: false
};

ExternalSearchLink.propTypes = {
  query: PropTypes.string.isRequired,
  searchType: PropTypes.string.isRequired,
  formatted: PropTypes.bool,
  intl: intlShape
};

ExternalSearchLink.displayName = 'ExternalSearchLink';

export default injectIntl(ExternalSearchLink);



// WEBPACK FOOTER //
// ./app/components/search/ExternalSearchLink.jsx